/* global angular */
( function () {
	'use strict';

	function canvasHelper () {
		var self = this;

		function getAllData () {
			return self.data;
		}

		function getData () {
			return self.data;
		}

		function setObsData ( data ) {
			self.data.observation = data;
		}

		function setSectionData ( data ) {
			self.data.sections[ data.id ] = data;
		}

		function setData ( data, type ) {
			var setDataFn = {
				'Observation' : setObsData,
				'Section'     : setSectionData
			};

			( setDataFn[ type ] || angular.noop )( data );
		}

		function clearData () {
			self.data = {
				'observation' : {},
				'sections'    : {}
			};
		}

		function activate () {
			self.data = {
				'observation' : {},
				'sections'    : {}
			};
		}

		activate();

		return {
			'getData'    : getData,
			'setData'    : setData,
			'getAllData' : getAllData,
			'clearData'  : clearData
		};
	}

	angular.module( 'app.report' )
		.factory( 'canvasHelper', canvasHelper );
} )();
